import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  selectedFiltersContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gridColumn: 'span 16'
  },
  chip: {
    display: 'inline-flex',
    mr: '16px',
    mb: '12px',
    fontSize: theme.fontSizes.smallText,
    padding: '4px 6px 4px 12px',
    border: `1px solid ${theme.rawColors.lightGrey300}`,
    background: theme.rawColors.neutralWhite,
    '.a-voxButton': {
      height: '24px'
    }
  },
  resetAddFiltersContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gridColumn: 'span 8'
  },
  resetAllFiltersButton: {
    background: 'none',
    outline: 'none',
    border: 'none',
    position: 'relative',
    height: '32px',
    display: 'inline-flex',
    ...reusables.mainTransition('color'),
    '&:hover': {
      color: theme.rawColors.accent700
    }
  }
};